import { useRef, useCallback } from "react";

import { usePeerVideoRefs } from "../../audioRefContext";

export function useAudioQueue() {
	const audioQueue = useRef([]);
	const isPlaying = useRef(false);
	const audioRef = useRef(new Audio());
	const currentlyPlayingId = useRef("");

	const playNext = useCallback(() => {
		console.log("IN THE PLAYNEXT");

		if (audioQueue.current.length === 0) {
			isPlaying.current = false;
			currentlyPlayingId.current = "";
			return;
		}

		isPlaying.current = true;
		const nextUrl = audioQueue.current.shift();
		console.log("nextUrl", nextUrl);
		audioRef.current.src = nextUrl.url;
		currentlyPlayingId.current = nextUrl.peerId;

		audioRef.current.onended = () => {
			URL.revokeObjectURL(nextUrl);
			playNext();
		};

		audioRef.current.play().catch(() => {
			playNext();
		});
	}, []);

	const enqueueAudio = useCallback(
		(audioObj) => {
			const { peerId, blob } = audioObj;

			const url = URL.createObjectURL(blob);
			audioQueue.current.push({ peerId, url });

			console.log("audioQueue.current:", audioQueue.current);
			console.log("isPlaying:", isPlaying);

			if (!isPlaying.current) {
				playNext();
			}
		},
		[playNext]
	);

	const clearQueue = useCallback(() => {
		console.log("Clearing the queue", audioQueue.current);
		audioQueue.current.forEach((elem) => {
			elem.url = URL.revokeObjectURL;
		});
		audioQueue.current = [];
		if (audioRef.current) {
			audioRef.current.pause();
		}
		isPlaying.current = false;
	}, []);

	return { enqueueAudio, clearQueue, audioRef };
}
